import React from "react";
import Layout from "../layout/defaultLayout";
import CodeEditor from "../components/Editor/codeEditor";
import CodeDisplay from "../components/codeDisplay/codeDisplay";
import Sidebar from "../components/sidebar/sideBar";
import { Link } from "react-router-dom";
import { Run, Download, SplitCode, Light, Dark } from "../assets/svg";
import Header from "../components/header/header";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: `<h1> Hello world </h1>`,
      execCode: `<h1> Hello world </h1>`,
      codeHTML: `<div class="hello">Hello world</div>`,
      codeCSS: `.hello{ color:green}`,
      codeJS: `console.log("Hello World")`,
      html: `<div class="hello">Hello world</div>`,
      css: `.hello{ color:green}`,
      js: `console.log("Hello World")`,
      split: false,
      dark: false,
      theme: "dawn",
    };
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleExecution = this.handleExecution.bind(this);
    this.getSideBarOptions = this.getSideBarOptions.bind(this);
    this.SaveFile = this.SaveFile.bind(this);
  }
  handleCodeChange(e) {
    this.setState({ code: e });
  }
  handleExecution() {
    this.setState({
      execCode: this.state.code,
      css: this.state.codeCSS,
      js: this.state.codeJS,
      html: this.state.codeHTML,
    });
  }
  SaveFile = () => {
    var content = "";
    if (this.state.split) {
      let tempContent = `<html>
      <header>Front-end Editor</head>
      <style>${this.state.css}</style>
      <body>${this.state.html}
      <script type="text/javascript"> ${this.state.js}</script>
      </body>
      </html>`;
      content += tempContent;
    } else {
      let tempContent = `<html><header>Front-end Editor</head><style>${this.state.execCode}</body></html>`;
      content += tempContent;
    }
    const element = document.createElement("a");
    const file = new Blob([content], {
      type: "text/html",
    });
    element.href = URL.createObjectURL(file);
    element.download = "download.txt";
    document.body.appendChild(element);
    element.click();
  };
  getSideBarOptions() {
    return (
      <div className="sidebar-cont">
        <Link
          className="side-bar-options"
          style={{
            color:"black",
            backgroundColor:"white",
            padding:"20px",
            margin:"0px"

          }}
          onClick={() => {
            this.handleExecution();
          }}
        >
         FE
        </Link>
        <Link
          className="side-bar-options"
          onClick={() => {
            this.handleExecution();
          }}
        >
          <Run />
        </Link>
        <Link className="side-bar-options" onClick={this.SaveFile}>
          <Download />
        </Link>
        <Link
          className="side-bar-options"
          onClick={() => {
            this.setState({ split: !this.state.split });
          }}
        >
          <SplitCode />
        </Link>
        <Link
          className="side-bar-options"
          onClick={() => {
            this.setState(
              {
                theme: this.state.dark ? "dawn" : "nord_dark",
              },
              () => {
                this.setState({
                  dark: !this.state.dark,
                });
              }
            );
          }}
        >
          {this.state.dark ? <Dark /> : <Light />}
        </Link>
      </div>
    );
  }
  render() {
    return (
      <Layout>
        <Header />
        <div className="main-content">
          <Sidebar options={this.getSideBarOptions} />
          <div className="main-content-editor">
            {this.state.split ? (
              <>
                <CodeEditor
                  handleCodeChange={(e) => {
                    this.setState({ codeHTML: e });
                  }}
                  type="html"
                  code={this.state.codeHTML}
                  theme={this.state.theme}
                />
                <CodeEditor
                  handleCodeChange={(e) => {
                    this.setState({ codeCSS: e });
                  }}
                  type="css"
                  code={this.state.codeCSS}
                  theme={this.state.theme}
                />
                <CodeEditor
                  handleCodeChange={(e) => {
                    this.setState({ codeJS: e });
                  }}
                  type="javascript"
                  code={this.state.codeJS}
                  theme={this.state.theme}
                />
              </>
            ) : (
              <CodeEditor
                handleCodeChange={this.handleCodeChange}
                type="html"
                code={this.state.code}
                theme={this.state.theme}
              />
            )}
          </div>
          <div className="main-content-iframe">
            {this.state.split ? (
              <CodeDisplay
                execCode={this.state.execCode}
                split={true}
                css={this.state.css}
                js={this.state.js}
                html={this.state.html}
              />
            ) : (
              <CodeDisplay execCode={this.state.execCode} split={false} />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

export default Index;
